// Popover menu from a top-bar button: closes on Escape, on outside click and when focus leaves.
import { useEffect, useRef, useState, type ReactNode } from "react";

export function Popover({ button, label, children, align = "right" }: { button: (p: { open: boolean; toggle: () => void }) => ReactNode; label: string; children: (close: () => void) => ReactNode; align?: "left" | "right" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const click = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    const key = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", click);
    document.addEventListener("keydown", key);
    return () => { document.removeEventListener("mousedown", click); document.removeEventListener("keydown", key); };
  }, [open]);
  return (
    <div ref={ref} className="relative">
      {button({ open, toggle: () => setOpen((o) => !o) })}
      {open && (
        <div role="dialog" aria-label={label} className={`absolute top-full z-30 mt-1 w-80 max-w-[calc(100vw-16px)] rounded-lg border border-line bg-raised p-2 shadow-pop ${align === "right" ? "right-0" : "left-0"}`}>
          {children(() => setOpen(false))}
        </div>
      )}
    </div>
  );
}
